
export module Extensions {

	export function init(): void {
		functionExtensions();
		stringExtensions();
		jqueryExtensions();
	}

	function functionExtensions(): void {
		Function.prototype["tryCall"] = function (...args: any[]) {
			if ((this != null) && (typeof this == "function"))
				return this.call(args);
		};
	}

	function stringExtensions() {

		String.prototype["format"] = String["format"] = function ():string {
			/// <summary>
			/// Formats a string by replacing the  {n} tokens, where 'n' is an integer index starting from zero, with the corresponding argument
			/// </summary>
			/// <returns type="string">the formatted string</returns>

			for (var i = 1; i < arguments.length; i++) {
				var exp = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
				arguments[0] = arguments[0].replace(exp, arguments[i]);
			}
			return arguments[0];
		};

		String.prototype["isNullOrWhiteSpace"] = String["isNullOrWhiteSpace"] = function (): Boolean {
			/// <summary>
			/// Formats a string by replacing the  {n} tokens, where 'n' is an integer index starting from zero, with the corresponding argument
			/// </summary>
			/// <returns type="string">the formatted string</returns>

			return (this == null) || ((<string>this).trim() == "");
		};

	}

	function jqueryExtensions() {

		$.fn.valSelect = function (val?: any): JQuery {
			if (typeof (val) == "undefined")
				return <any>(<JQuery>this).val();

			return (<JQuery>this).val(val).trigger("change");
		};


		$.fn.checked = function (val?: boolean): JQuery {
			if (typeof (val) == "undefined")
				return (<JQuery>this).prop("checked");

			return (<JQuery>this).prop("checked", val).trigger("change");
		};

	}

}




